import React, {Component} from 'react'

import Base from '../BaseComponent'

class Link extends Component {

  render () {

    let className = 'Link';
    let output = (this.props.className) ? this.props.className : '';

    output += ' '+className;

    if(this.props.modifiers) {

      this.props.modifiers.forEach((m) => output += ' '+className+'--'+m);

    }

    return (
      <a href={this.props.url} className={output} target={(this.props.blank == true) ? "_blank" : ""}>{this.props.title}</a>
    )
  }
}

export default Link



// WEBPACK FOOTER //
// ./src/js/components/Link/Link.jsx